import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';

@Injectable()
export class CompaniesQueryService {
    private CREATE_COMPANY_LOGO_DATA: any;
    private GET_ALL_COMPANY_LOGO__DATA: any;
    private DELETE_COMPANY_LOGO_DATA: any;

    constructor(public apollo: Apollo) {
        //Create inspection report  detail
        this.CREATE_COMPANY_LOGO_DATA = gql` 
        mutation CREATE_COMPANY_LOGO($input: CreateCompanyInput!) {
            createCompany(input: $input) {
                company{
                    nodeId  
                    id     
                }
        }
        }
      `;

        this.GET_ALL_COMPANY_LOGO__DATA = gql`
            query{
                allCompanies(orderBy:CREATEDAT_DESC) {
                    
                    nodes {
                        id
                        logourl
                        createdat
                        }
                    
                }
            }
            `;

        this.DELETE_COMPANY_LOGO_DATA = gql`
            mutation DELETE_COMPANY_LOGO_DATA($input:DeleteCompanyByIdInput!){
               deleteCompanyById(input:$input){
               deletedCompanyId
             }
          }
        `;


    }
    // Uplaod logo
    UPLOAD_COMPANY_LOGO(fileName) {
        return this.apollo.mutate({
            mutation: this.CREATE_COMPANY_LOGO_DATA,
            variables: {
                "input": {
                    "company": {
                        "logourl": fileName,
                        "createdat": new Date(),
                    }
                }
            },
        })
    }


    // GET All COMPANY LOGO IMG
    GET_ALL_COMPANY_LOGO() {
        return this.apollo.watchQuery({
            query: this.GET_ALL_COMPANY_LOGO__DATA,
            fetchPolicy: 'network-only'
        })
    }

   //Delete Selected company data
   DELETE_COMPANY_LOGO(companyId) {
    return this.apollo.mutate({
        mutation: this.DELETE_COMPANY_LOGO_DATA,
        variables: {
            "input": {
                "id": companyId
            }
        }
    })
   }  
 

}


// WEBPACK FOOTER //
// I:/1.speKwo/New Spekwo Revamp/admindash/src/app/main/content/apps/queryFiles/companies.ts